import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import { colors } from 'vuetify/lib';
Vue.use(Vuetify);

/*
export default new Vuetify({
});
*/

export default new Vuetify({
    theme: {
      dark: true,
      themes: {
        dark: {
          primary:"#ffffff",
          secondary:"#43dcca",
          accent:"#FFE200",
          light:"#f2f2f2",
          background:"#00133E",
        },
        light: {
          primary:"#ffffff",
          secondary:"#43dcca",
          accent:"#fd0a8c",
          background:"#00133E",
        },
      },
    },
});
